import React from "react";
import { Form, Modal } from "react-bootstrap";
import {
  ActionIconContainer,
  AddFormButton,
  CustomLoader,
} from "../../shared/components/TableElements";
import { useForm } from "react-hook-form";
import { emailPattern } from "../../shared/helpers";
import {
  FormGroupLabel,
  FormItem,
} from "../../shared/components/form/FormElements";
import { useTranslation } from "react-i18next";
import { formInputStyles } from "../../shared/constants/styles";
import FormField from "../../shared/components/form/FormField";
import Error from "@/shared/components/form/Error";
import { useAuth } from "../../contexts/AuthContext";
import { useHistory } from "react-router";
import styled from "styled-components";
const ContactSupportModal = ({
  show,
  onClose,
  saveBtnLoading,
  onContactSupport,
}) => {
  const {
    handleSubmit,
    reset,
    register,
    control,
    watch,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();
  const { t } = useTranslation("common");
  const { tag } = useAuth();
  const history = useHistory();

  //hook form variables
  const desc = watch("desc");
  const email = watch("email");
  const phone = watch("phone");

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header>
        <h4>{t("contact_support_for_custom_report")}</h4>
        <div className="d-flex justify-content-end">
          <ActionIconContainer onClick={onClose}>
            <i className="fi fi-rr-cross-small" />
          </ActionIconContainer>
        </div>
      </Modal.Header>
      <Form onSubmit={handleSubmit(onContactSupport)}>
        <Modal.Body>
          {tag === "advanced-user" ? (
            <>
              <Form.Group>
                <FormGroupLabel className="m-0">{t("desc")}</FormGroupLabel>
                <FormItem disabled={false}>
                  <FormField
                    name="desc"
                    control={control}
                    component="textarea"
                    defaultValue=""
                    placeholder={t("custom_report_desc_placeholder")}
                    style={{ ...formInputStyles, lineHeight: "auto" }}
                    disabled={false}
                    rules={{ required: t("required_err") }}
                  />
                </FormItem>

                {errors?.desc && <Error error={errors.desc.message} />}
              </Form.Group>
              <Form.Group>
                <FormGroupLabel>{t("email")}</FormGroupLabel>
                <FormItem
                  //disabled={type === "edit"}
                  id="email-input-div"
                  //tabIndex={0}
                >
                  <FormField
                    name="email"
                    id="email-input"
                    control={control}
                    component="input"
                    defaultValue=""
                    //isAboveError={isAboveError}
                    placeholder={t("email")}
                    rules={{
                      required: t("required_err"),
                      pattern: {
                        value: emailPattern,
                        message: t("invalid_email_err_msg"),
                      },
                    }}
                    style={formInputStyles}
                    //disabled={type === "edit"}
                  />
                </FormItem>

                {errors?.email && <Error error={errors.email.message} />}
              </Form.Group>
              <Form.Group className="mb-3">
                <FormGroupLabel>{`${t("phone")} (${t(
                  "optional"
                )})`}</FormGroupLabel>
                <FormItem disabled={false}>
                  <FormField
                    name="phone"
                    control={control}
                    component="input"
                    defaultValue=""
                    //isAboveError={isAboveError}
                    placeholder={t("phone")}
                    style={formInputStyles}
                    disabled={false}
                    //onKeyUp={handleSIOdoChange}
                  />
                </FormItem>

                {errors?.phone && <Error error={errors.phone.message} />}
              </Form.Group>
            </>
          ) : (
            <div>
              <p>{t("custom_reports_in_advanced_plan_msg")}</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {tag === "advanced-user" ? (
            <AddFormButton
              id="save-form-button"
              type="submit"
              disabled={!desc?.trim() || !email?.trim()}
              //onClick={() => handleSubmit(onContactSupport)}
            >
              {saveBtnLoading ? <CustomLoader /> : t("submit")}
            </AddFormButton>
          ) : (
            <AddFormButton
              type="button"
              onClick={() => history.push("/billing")}
            >
              {t("go_to_billing")}
            </AddFormButton>
          )}
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

const ModalHeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  /* RTL: Title on right, close button on left */
  flex-direction: ${(props) =>
    props.theme.direction === "rtl" ? "row-reverse" : "row"};
`;

const ModalTitle = styled.h4`
  margin: 0;
  text-align: ${(props) =>
    props.theme.direction === "rtl" ? "right" : "left"};
`;

const ModalFooterContent = styled.div`
  display: flex;
  justify-content: ${(props) =>
    props.theme.direction === "rtl" ? "flex-start" : "flex-end"};
  width: 100%;
`;

export default ContactSupportModal;
